import { AUTOMATION_STATUSES } from './automation';
import { GIFT_STATUSES, ORDER_STATUSES } from './giftStatus';
import { ORGANIZATION_STATUS } from './organization';
import { PAYMENT_METHOD_STATUS } from './paymentMethod';
import { RECOGNITION_STATUSES } from './recognition';

export const BADGES = {
  [AUTOMATION_STATUSES.active]: {
    title: 'active',
    color: 'var(--color-success-weak)',
    background: 'var(--color-accent-primary-weakest)'
  },
  [AUTOMATION_STATUSES.deactivated]: {
    title: 'deactivated',
    color: 'var(--color-accent-secondary-weaker)',
    background: 'var(--color-fg-weak)'
  },
  [AUTOMATION_STATUSES.readyToActivate]: {
    title: 'readyToActivate',
    color: 'var(--color-info-weak)',
    background: 'var(--color-info-weak)'
  },
  [GIFT_STATUSES.emailDelivered]: {
    title: 'emailDelivered',
    color: 'var(--color-success-weak)',
    background: 'var(--color-accent-primary-weakest)'
  },
  [GIFT_STATUSES.emailNotDelivered]: {
    title: 'emailNotDelivered',
    color: 'var(--color-error-weak)',
    background: 'var(--color-error-weak)'
  },
  [GIFT_STATUSES.emailOpened]: {
    title: 'emailOpened',
    color: 'var(--color-info-weak)'
  },
  [GIFT_STATUSES.giftLinkCreated]: {
    title: 'giftLinkCreated',
    color: 'var(--color-accent-secondary-weaker)',
    background: 'var(--color-fg-weak)'
  },
  [GIFT_STATUSES.giftOpened]: {
    title: 'giftOpened',
    color: 'var(--color-accent-primary-weak)',
    background: 'var(--color-accent-primary-weakest)'
  },
  [GIFT_STATUSES.orderAccepted]: {
    title: 'orderAccepted',
    color: 'var(--color-error-weak)',
    background: 'var(--color-error-weak)'
  },
  [GIFT_STATUSES.orderDelivered]: {
    title: 'orderDelivered',
    color: 'var(--color-success-weak)',
    background: 'var(--color-accent-primary-weakest)'
  },
  [GIFT_STATUSES.orderSubmissionPending]: {
    title: 'orderSubmissionPending',
    color: 'var(--color-info-weak)',
    background: 'var(--color-info-weak)'
  },
  [GIFT_STATUSES.orderSubmissionStarted]: {
    title: 'orderSubmissionStarted',
    color: 'var(--color-success-weak)',
    background: 'var(--color-accent-primary-weakest)'
  },
  [GIFT_STATUSES.orderSubmissionSkipped]: {
    title: 'orderSubmissionSkipped',
    color: 'var(--color-warning-weak)',
    background: 'var(--color-warning-weak)'
  },
  [GIFT_STATUSES.orderSubmissionFailed]: {
    title: 'orderSubmissionFailed',
    color: 'var(--color-error-weak)',
    background: 'var(--color-error-weak)'
  },
  [GIFT_STATUSES.orderSubmitted]: {
    title: 'orderSubmitted',
    color: 'var(--color-success-weak)',
    background: 'var(--color-accent-primary-weakest)'
  },
  [GIFT_STATUSES.upcoming]: {
    title: 'upcoming',
    color: 'var(--color-accent-secondary-weaker)',
    background: 'var(--color-fg-weak)'
  },
  [ORDER_STATUSES.accepted]: {
    title: 'accepted',
    color: 'var(--color-error-weak)',
    background: 'var(--color-error-weak)'
  },
  [ORDER_STATUSES.approved]: {
    title: 'approved',
    color: 'var(--color-info-weak)',
    background: 'var(--color-info-weak)'
  },
  [ORDER_STATUSES.opened]: {
    title: 'opened',
    color: 'var(--color-warning-weak)',
    background: 'var(--color-warning-weak)'
  },
  [ORDER_STATUSES.injected]: {
    title: 'paid',
    color: 'var(--color-success-weak)',
    background: 'var(--color-accent-primary-weakest)'
  },
  [ORDER_STATUSES.invoiceCreated]: {
    title: 'invoiceCreated',
    color: 'var(--color-success-weak)',
    background: 'var(--color-accent-primary-weakest)'
  },
  [ORDER_STATUSES.noInvoiceYet]: {
    title: 'noInvoiceYet',
    color: 'var(--color-info-weak)',
    background: 'var(--color-info-weak)'
  },
  [RECOGNITION_STATUSES.draft]: {
    title: 'draft',
    color: 'var(--color-warning-weak)',
    background: 'var(--color-warning-weak)'
  },
  [RECOGNITION_STATUSES.pending_approval]: {
    title: 'approvalPending',
    color: 'var(--color-warning-weak)',
    background: 'var(--color-warning-weak)'
  },
  [RECOGNITION_STATUSES.expired]: {
    title: 'ended',
    color: 'var(--color-accent-secondary-weaker)',
    background: 'var(--color-fg-weak)'
  },
  [RECOGNITION_STATUSES.live]: {
    title: 'live',
    color: 'var(--color-success-weak)',
    background: 'var(--color-accent-primary-weakest)'
  },
  [RECOGNITION_STATUSES.readyToSend]: {
    title: 'readyToSend',
    color: 'var(--color-info-weak)',
    background: 'var(--color-info-weak)'
  },
  [PAYMENT_METHOD_STATUS.inactive]: {
    title: 'inactive',
    color: 'var(--color-accent-secondary-weaker)'
  },
  [RECOGNITION_STATUSES.archived]: {
    title: 'archived',
    color: 'var(--color-accent-secondary-weaker)',
    background: 'var(--color-fg-weak)'
  },
  [RECOGNITION_STATUSES.starting]: {
    title: 'processing',
    color: 'var(--color-warning-weak)',
    background: 'var(--color-warning-weak)'
  },
  [RECOGNITION_STATUSES.error_on_start]: {
    title: 'processingError',
    color: 'var(--color-error-weak)',
    background: 'var(--color-error-weak)'
  },
  [ORGANIZATION_STATUS.pending]: {
    title: 'pending',
    color: 'var(--color-warning-weak)',
    background: 'var(--color-warning-weak)'
  },
  Customized: {
    title: '',
    color: 'var(--color-success-weak)',
    background: 'var(--color-accent-primary-weakest)'
  },
  default: {
    title: '',
    color: 'var(--color-success-weak)',
    background: 'var(--color-accent-primary-weakest)'
  },
  activeInvite: {
    title: 'active',
    color: 'var(--color-success-weak)',
    background: 'var(--color-accent-primary-weakest)'
  },
  pendingInvite: {
    title: 'pending',
    color: 'var(--color-warning-weak)',
    background: 'var(--color-warning-weak)'
  },
  expiredInvite: {
    title: 'expired',
    color: 'var(--color-error-weak)',
    background: 'var(--color-error-weak)'
  }
};
